import { render, staticRenderFns } from "./submission-notification.vue?vue&type=template&id=2cbbf1e2&scoped=true&"
import script from "./submission-notification.vue?vue&type=script&lang=ts&"
export * from "./submission-notification.vue?vue&type=script&lang=ts&"
import style0 from "./submission-notification.vue?vue&type=style&index=0&id=2cbbf1e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbbf1e2",
  null
  
)

export default component.exports